import Vue from 'vue';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

import App from './App.vue';
import { router } from './config/router/router';
import { i18n } from './i18n/i18n';
import vuetify from './config/vuetify/vuetify';
import ckeditor from './config/ckeditor/ckeditor';

import { store } from './store/store';
import './config/vee-validate/vee-validate';

// Import mixins
import './utils/mixins/index';
// Import filters
import './utils/filters/index';

import './assets/scripts/app';

Vue.config.productionTip = false;

Vue.use(VueMoment, {
    moment,
});


new Vue({
  router,
  store,
  i18n,
  vuetify,
  ckeditor,
  render: h => h(App),
}).$mount('#app');
